import {Context, createContext} from 'solid-js'
import {RemoteInputProviderBehavior} from './RemoteInputProvider'

export const RemoteInputContext: Context<RemoteInputProviderBehavior> = createContext({
    remoteNumInput: '',
    remoteNumInputCleanUp: () => {},
    customPlayback: () => {},
    setRemoteNumInput: () => {},
    setLayoutInterval: () => {},
    layoutInterval: '',
    remoteInputPlay: '',
})
